import React from 'react'
import './AmenitiesT2.scss'
import PropTypes from 'prop-types'
import { EditAmenities } from '@components/custom'
import { EditButtonWrapper } from '@components/common'

export class AmenitiesT2 extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      dialog: false
    }
  }

  handleAmenitiesDialog = () => {
    this.setState({
      dialog: !this.state.dialog
    })
  }

  chunk = (size, xs) =>
    xs.reduce((segments, _, index) => {
      if (index % size === 0) {
        return [...segments, xs.slice(index, index + size)]
      }

      return segments
    }, [])

  render() {
    const {
      editPropertyData,
      amenitiesCount,
      amenities,
      propertyType,
      themeColors,
      disclaimerText,
      showDisclaimer
    } = this.props
    const { dialog } = this.state
    const amenitiesFrmProps = this.props.amenities
    const amenitiesInGrp = amenitiesFrmProps && this.chunk(2, amenitiesFrmProps)

    const headingStyle = propertyType?.toString().includes('S')
      ? {
          color: themeColors.subjectSectionHeadingColor
        }
      : {
          color: themeColors.comparableSectionHeadingColor
        }

    const bulletStyle = {
      position: 'relative',
      left: '0',
      top: '0',
      backgroundColor: propertyType.toString().includes('S')
        ? themeColors.subjectTextbulletColor
        : themeColors.comparableTextbulletColor,
      width: '5px',
      height: '5px',
      borderRadius: '50%'
    }

    return (
      <React.Fragment>
        <div className="amenitiesT2">
          <div
            data-testid="amenities"
            className="amenitiesT2__heading"
            style={headingStyle}
          >
            AMENITIES
          </div>
          <EditButtonWrapper
            isTruncated={amenities?.length > amenitiesCount}
            handleEditButtonClick={this.handleAmenitiesDialog}
            dataTestId="amenitiesT2_edit"
          >
            <div className="amenitiesT2__block">
              {amenitiesInGrp &&
                amenitiesInGrp.map((list, i) => (
                  <div key={i} className="amenitiesT2-item">
                    {list.map((amenitie, j) =>
                      (i < amenitiesCount / 2 ? (
                        <div className="item" key={j}>
                          <div style={bulletStyle} />
                          <div className="items">{amenitie.trim()}</div>
                        </div>
                      ) : (
                        ''
                      ))
                    )}
                  </div>
                ))}
            </div>
            {showDisclaimer && (
              <div className="amenitiesT2__disclaimer">{disclaimerText}</div>
            )}
          </EditButtonWrapper>
        </div>
        <EditAmenities
          disclaimerText={disclaimerText}
          showDisclaimer={showDisclaimer}
          dialog={dialog}
          amenities={amenities}
          chunk={this.chunk}
          editPropertyData={editPropertyData}
          amenitiesCount={amenitiesCount}
          handleAmenitiesDialog={this.handleAmenitiesDialog}
        />
      </React.Fragment>
    )
  }
}

AmenitiesT2.propTypes = {
  showDisclaimer: PropTypes.bool,
  disclaimerText: PropTypes.string,
  amenities: PropTypes.array,
  editPropertyData: PropTypes.func,
  amenitiesCount: PropTypes.number,
  propertyType: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  themeColors: PropTypes.object
}

export default AmenitiesT2
